import {
  FluidButtonType,
  FluidContainerElementType,
  FluidEmptyStateConfig,
  FluidIconConfig,
  FluidIconKey,
  FluidLoadingSpinnerConfig,
  FluidRowData,
  FluidTableAction,
} from '@lmig/fluid-core';
import { FluidTableTranslationOptions } from '@lmig/fluid-core/lib/i18n/types/fluid-table-translation-options.type';
import { h } from '@stencil/core';

import { TABLE_FILTER_NO_ROWS } from '../../../constants/constants';

// ================================================================ //
// -- Table Empty States

export interface FluidTableEmptyStateConfig {
  /**
   * @deprecated
   */
  action?: FluidTableAction;

  actions?: FluidTableAction[];
  icon?: FluidIconConfig;
  message?: string;
}

// ================================================================ //
// -- Loading State

export const TableLoadingState = (props: {
  spinnerProps?: FluidLoadingSpinnerConfig;
  dataLoading: boolean;
  visibleDataItems: FluidRowData[];
  dataItems: FluidRowData[];
  fluidTranslate?: FluidTableTranslationOptions;
}) => {
  const {
    dataLoading,
    visibleDataItems,
    dataItems,
    spinnerProps,
    fluidTranslate,
  } = props;
  return (
    dataLoading &&
    (visibleDataItems?.length > 0 || dataItems?.length === 0) && (
      <div class='overlay'>
        <fluid-loading-spinner
          {...spinnerProps}
          fluidTranslate={{ loadingMessage: fluidTranslate?.loadingMessage }}
        />
      </div>
    )
  );
};

// ================================================================ //
// -- No Results (when filters applied) State

export const TableEmptyFilterState = (props: {
  filtersApplied: boolean;
  visibleDataItems: FluidRowData[];
  clearFilters: Function;
}) => {
  const { filtersApplied, visibleDataItems, clearFilters } = props;
  const emptyStateConfig: FluidEmptyStateConfig = {
    bodyText: TABLE_FILTER_NO_ROWS,
    action: [
      {
        identifier: 'clearFilters',
        label: 'Clear Filters',
        type: FluidButtonType.PRIMARY,
      },
    ],
    iconConfig: {
      key: FluidIconKey.FILTER,
    },
  };

  return (
    <TableEmptyState
      emptyStateConfig={emptyStateConfig}
      showEmptyState={filtersApplied}
      actionClick={() => clearFilters()}
      visibleDataItems={visibleDataItems}
    />
  );
};

// ================================================================ //
// -- Configured Empty State (no filters applied, but no data in table)

export const TableEmptyState = (props: {
  visibleDataItems?: FluidRowData[];
  showEmptyState?: boolean;
  emptyStateConfig?: FluidEmptyStateConfig;
  actionClick?: Function;
  overlay?: boolean;
  loading?: boolean;
  fluidTranslate?: FluidTableTranslationOptions;
}) => {
  const {
    showEmptyState,
    visibleDataItems,
    emptyStateConfig,
    actionClick,
    overlay,
    loading,
    fluidTranslate,
  } = props;

  if (!emptyStateConfig || loading) return;

  const { iconConfig, titleText, bodyText } = emptyStateConfig;
  const doRender = overlay
    ? showEmptyState
    : visibleDataItems.length === 0 && showEmptyState;

  const emptyStateIcon = {
    ...iconConfig,
  };

  return (
    doRender && (
      <fluid-empty-state-container
        fluidTranslate={fluidTranslate?.emptyStateConfig}
        iconConfig={emptyStateIcon}
        actions={emptyStateConfig?.action}
        titleText={titleText}
        bodyText={bodyText}
        type={FluidContainerElementType.COMPONENT}
        onActionClicked={() => actionClick()}></fluid-empty-state-container>
    )
  );
};
